import React from 'react';
import { ReferralTermsAndConditionContain } from './ReferralTCContain';
import parser from 'html-react-parser';

const ReferralTermsConditions: React.FC = () => {
    return (
        <div className="pt-4">
            <p className="mt-6 mb-6 w-full text-center sm:text-center md:text-left text-2xl color-[#20222b] page_title">
                {' '}
                Helicap Investor Referral Rebate Program - Terms and Conditions
            </p>
            <div className="rounded-md overflow-hidden shadow-lg bg-white h-full relative m-auto mt-4">
                <div className="px-4 py-4">
                    {ReferralTermsAndConditionContain.map((tc, index) => (
                        <div className="text-base" key={`${tc.title}_${index}`}>
                            <p className="SourceSansPro-Bold text-base underline font-bold">{tc.title}</p>
                            <div className="py-4 SourceSansPro text-justify">{parser(String(tc.child))}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ReferralTermsConditions;
